import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Button, Modal, Table, Spinner, Alert, Dropdown } from 'react-bootstrap';
import { DataManager } from '../../../core/data-manager';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ModalEntityViewer from '../../../components/Modals/ModalEntityViewer';
import ModalList from '../../../components/Modals/ModalList';
import { toast } from 'react-toastify';



export default function DGLTH_item_model_open_row({ item, entity = null, refreshData }) {

    const navigate = useNavigate();

    const [statusModalListStorico, setStatusModalListStorico] = useState(false)
    const [statusModalListFornitori, setStatusModalListFornitori] = useState(false)
    const searchObjStorico = {
        'query': '',
        'fields': [],
        'constraints': [
            { fieldName: "idItemModel", type: "value", value: item.id_item }
        ]
    }
    const searchObjFornitori = {
        'query': '',
        'fields': [],
        'constraints': [
            { fieldName: "itemCode", type: "value", value: item.item_code }
        ]
    }

    function closeModalListStorico() {
        setStatusModalListStorico(false)
    }

    function openModalListStorico() {
        setStatusModalListStorico(true);
    }
    function closeModalListFornitori() {
        setStatusModalListFornitori(false)
    }

    function openModalListFornitori() {
        setStatusModalListFornitori(true);
    }

    async function openMpm() {
        var sorting = {
            'field': 'id',
            'order': 'asc'
        }
        let constraints = [
            { fieldName: "idItemModel", type: "value", value: item.id_item },
            { fieldName: "isDefault", type: "value", value: 1 }
        ]
        var response = await DataManager.searchItems('manufacturing_process_model', 1, 20, sorting, '', [], constraints);
        if (response.success === 1 && response.body.length !== 0) {
            var idMpm = response.body[0].id
            window.open('/page/MpmTree2?id=' + idMpm)
        }
        else {
            toast.error("Questo articolo non ha una distinta base associata.", { theme: 'colored' })
        }

    }

    async function noBindella() {
        const updateData = {
            bindella: 0
        }
        const response = await DataManager.updateItem('customer_order_rows', updateData, item.id);
        if (response.success === 1) {
            toast.success("Bindella impostata a NO.", { theme: 'colored' })
            refreshData()
        } else {
            toast.error("Errore nell'aggiornamento della bindella.", { theme: 'colored' })
        }
    }


    return (
        <>
            
            <Dropdown>
                <Dropdown.Toggle variant="secondary" id="dropdown-basic" size='sm'>
                    Azioni
                </Dropdown.Toggle>

                <Dropdown.Menu>
                    <Dropdown.Item onClick={() => openMpm()}>Distinta Base</Dropdown.Item>
                    <Dropdown.Item onClick={() => openModalListStorico()}>Storico movimentazioni</Dropdown.Item>
                    <Dropdown.Item onClick={() => openModalListFornitori()}>Listino fornitori</Dropdown.Item>
                    <Dropdown.Item onClick={() => navigate('/page/BindellaOpenRow?id=' + item.id)}>Stampa bindella</Dropdown.Item>
                    <Dropdown.Item onClick={() => noBindella()}>No bindella</Dropdown.Item>

                </Dropdown.Menu>
            </Dropdown>


            {statusModalListStorico && (
                <ModalList entity={'item_model_movement'} searchObj={searchObjStorico} closeModal={closeModalListStorico} status={statusModalListStorico} />
            )}

            {statusModalListFornitori && (
                <ModalList entity={'gyv_all_supplier_item'} searchObj={searchObjFornitori} closeModal={closeModalListFornitori} status={statusModalListFornitori} />
            )}

        </>
    )
};